var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 288 288",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 216h216v-216h-216z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 288)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.49 216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-146.49-0.262v-107.93l0.194-107.81h69.16l146.65 0.263v107.93l-0.193 107.81z",
    fill: "#e7382f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.013 27.112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-16.99l-38.594 91.892h24.761l22.327-53.609 23.061 53.609h17.041l22.858-53.609 22.496 53.609h24.772l-38.589-91.892h-17.03l-23.026 53.418z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.74 188.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-10.957 0-19.823-8.902-19.823-19.882 0-10.986 8.866-19.898 19.823-19.898 10.978 0 19.828 8.912 19.828 19.898 0 10.98-8.85 19.882-19.828 19.882",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.fab24f6a68629ee08701529a7cb37f72.svg";
export { ForwardRef as ReactComponent };